import * as React from 'react';

import {
  Button,
  Card,
  Collapse,
  Divider,
  Drawer,
  Form,
  Input,
  notification,
  Progress,
  Row,
  Tag,

} from 'antd';
import { RcFile, UploadChangeParam } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';
import { InboxOutlined, ShopOutlined, SolutionOutlined, UserOutlined } from '@ant-design/icons';
import { L } from '../../../lib/abpUtility';

import LanguageSelect from '../../LanguageSelect';
import Meta from 'antd/es/card/Meta';


export interface IOptionsProps {

  formRef: any;
  isMobile: boolean;
  visible: boolean;
  loading: boolean;
  primaryColor: string;
  secondaryColor: string;
  defaultImage: string;
  profileImageID: number;
  userStore: any;

  firstName: string;
  lastName: string;
  email: string;

  onCreate: (values: any) => void;
  onCancel: () => void;
  uploadProfileImage: (file: any) => any;


  subscriptionType: any;
  subscriptionStart: any;
  subscriptionEnd: any;
  availableTemplates: any;


}

export interface IItemBaseState {
  imageUrl: string;
  imgLoading: boolean;
  userName: string;
  editModeOff: boolean;
}

class Options extends React.Component<IOptionsProps, IItemBaseState> {


  state =
    {
      fieldNameSize: '1.5em',
      imgLoading: false,
      imageUrl: '',
      userName: '',
      editModeOff: true
    };



  //-----------------------------------------------------------------
  // Image / File Methods
  //-----------------------------------------------------------------
  async uploadImage(file: RcFile) {
    this.setState({ imgLoading: true });
    let result = await this.props.uploadProfileImage(file);

    return result.url;
  }

  async getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  beforeUpload(file: RcFile, fileList: RcFile[]) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      notification.open({
        message: L('Uh Oh!'),
        description:
          L('Only JPG and PNG Images Allowed')
      });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notification.open({
        message: L('Uh Oh!'),
        description:
          L('Image must be smaller than 2MB')
      });
    }
    return isJpgOrPng && isLt2M;
  }

  handleChange = (info: UploadChangeParam<UploadFile<any>>) => {

    if (info.file.status === 'uploading') {
      this.setState({ imgLoading: true });
      return;
    }
    else {

      if (info.file.originFileObj !== undefined) {
        // Get this url from response in real world.
        this.getBase64(info.file.originFileObj, (imageUrl: any) =>
          this.setState({
            imageUrl,
            imgLoading: false,
          }),
        );
      }

    }

  };

  //-----------------------------------------------------------------
  // Form Clear/Complete Methods
  //-----------------------------------------------------------------
  handleFinish = (values: any) => {


    var valuesFormatted = {
      isActive: true,
      userName: this.props.formRef.current?.getFieldValue('emailAddress'),
      profileImageID: this.props.profileImageID,
      ...values
    };
    this.props.formRef.current?.resetFields();
    this.setState({ imageUrl: '' });
    this.props.onCreate(valuesFormatted);
  }

  handleCancel = () => {
    this.props.formRef.current?.resetFields();
    this.setState({ imageUrl: '', editModeOff: true })
    this.props.onCancel();
  }

  handleReset = async () => {


    if (this.state.editModeOff === true) {
      this.setState({ editModeOff: false })
    }
    else {

      let success: boolean = false;

      let currentPass = this.props.formRef.current?.getFieldValue('currentPassword1');
      let newPass1 = this.props.formRef.current?.getFieldValue('currentPassword2');
      let newPass2 = this.props.formRef.current?.getFieldValue('newPassword');

      if (newPass1 === newPass2) {

        success = await this.props.userStore.changePassword({ currentPassword: currentPass, newPassword: newPass2 })

        if (success === false) {

          notification.open({
            message: L('Password Reset Error'),
            description:
              L('Unable to Reset Password.')
          });
        }
        else {

          notification.open({
            message: L('Success'),
            description:
              L('Your password has been changed successfully.')
          });

          this.setState({ editModeOff: true });
          this.props.formRef.current?.resetFields();
        }

      }
      else {

        notification.open({
          message: L('Verify Password'),
          description:
            L('Please make sure your New Password fields match.')
        });

      }

    }


  }


  //-----------------------------------------------------------------

  render() {
    const { visible } = this.props;

    const { Panel } = Collapse;

    return (

      <div className="font-face-gm">

        <div>
          <Drawer
            onClose={this.handleCancel}
            closeIcon={false} closable={this.props.isMobile === true ? true : false}
            open={visible}

            width={window.innerWidth < 650 ? (window.innerWidth * 0.85) : 420} >
            <Divider className="font-face-gm" type="horizontal"
              style={{ fontSize: '2.3em', marginBottom: '0px', }} >
              {L('Options')}
            </Divider>
            <Row style={{ marginBottom: '0px' }}>
              <Progress
                strokeColor={{
                  from: this.props.secondaryColor,
                  to: this.props.primaryColor,
                }}
                showInfo={false}
                percent={100}
                status="normal"
                size={'small'}
              />
            </Row>


            <Collapse accordion={true}
              bordered={true}
              defaultActiveKey={'profile'}
              style={{
                fontSize: '1em',
                backgroundColor: 'transparent',
                marginBottom: '0px',
                marginTop: '5px',
                border: 'none',
                boxShadow: 'none'
              }}>

              <Panel className="font-face-gm"

                style={{ fontSize: '1.2em', }}
                header={<div style={{ marginLeft: '25px' }}><SolutionOutlined twoToneColor={this.props.secondaryColor} style={{ fontSize: 18, marginRight: '10px' }} />{L('Basic Info')}</div>}
                key={'profile'}>

                <Form ref={this.props.formRef} style={{ marginTop: '0px', marginBottom: '100px' }} name={'loginForm'}
                  onFinish={(e) => this.handleFinish(e)}>


                  <Card>


                    <div style={{ marginBottom: '70px', margin: 'auto',  }}>

                      <div style={{ width: '100%', float: 'left', padding: '0', margin: '0' }}>
                        <Form.Item>
                          <Meta avatar={<UserOutlined twoToneColor={this.props.secondaryColor} style={{ fontSize: 33, padding: '5px' }} />}
                            className="font-face-gm" title={<div style={{ fontSize: '1.1em', paddingBottom: '-10px', marginBottom: '5px', }}>{L('Name')}</div>}
                            description={<div style={{ fontSize: '1.1em', marginTop: '-15px', lineHeight: '15px' }}>{this.props.firstName}</div>}
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div style={{ marginBottom: '70px' }}>

                      <div style={{ width: '100%', float: 'left', padding: '0', margin: '0' }}>

                        <Form.Item>
                          <Meta avatar={<InboxOutlined twoToneColor={this.props.secondaryColor} style={{ fontSize: 33, padding: '5px' }} />} className="font-face-gm" title={<div style={{ fontSize: '1.1em', paddingBottom: '-10px', marginBottom: '5px', }}>{L('Email')}</div>}
                            description={<div style={{ fontSize: '1.1em', marginTop: '-15px', lineHeight: '15px' }}>{this.props.email}</div>}
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div>

                      <div style={{ float: 'left', width: '100%' }}>
                        <Form.Item>
                          <Meta avatar={<ShopOutlined twoToneColor={this.props.secondaryColor} style={{ fontSize: 33, padding: '5px' }} />} className="font-face-gm" title={<div style={{ fontSize: '1.1em', paddingBottom: '-10px', marginBottom: '5px', }}>{L('Organization')}</div>}
                            description={<div style={{ fontSize: '1.1em', marginTop: '-15px', lineHeight: '15px' }}>{this.props.lastName}</div>}
                          />
                        </Form.Item>
                      </div>

                    </div>
                  </Card>
                  <br />

                  {this.state.editModeOff === false ?

                    <div> <div>
                      <div style={{ float: 'left', width: '25%', marginRight: '12px' }}>
                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1.1em', textAlign: 'center', width: '100%', height: '40px', resize: 'block' }}
                          color={this.props.primaryColor}>{L('Current')}</Tag>
                      </div>
                      <div style={{ float: 'left', width: '70%' }}>
                        <Form.Item initialValue={L('Not Required')} className="font-face-gm" name={'currentPassword1'}   >

                          <Input placeholder={L('Enter Current Password...')} size="large" disabled={true} />

                        </Form.Item>
                      </div>

                    </div>
                      <div>
                        <div style={{ float: 'left', width: '25%', marginRight: '12px' }}>
                          <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1.1em', textAlign: 'center', width: '100%', height: '40px', resize: 'block' }}
                            color={this.props.primaryColor}>{L('New')}</Tag>
                        </div>
                        <div style={{ float: 'left', width: '70%' }}>
                          <Form.Item className="font-face-gm" name={'currentPassword2'}   >

                            <Input placeholder={L('Enter New Password...')} size="large" disabled={this.props.loading} />

                          </Form.Item>
                        </div>

                      </div>
                      <div>
                        <div style={{ float: 'left', width: '25%', marginRight: '12px' }}>
                          <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1.1em', textAlign: 'center', width: '100%', height: '40px', resize: 'block' }}
                            color={this.props.primaryColor}>{L('Confirm')}</Tag>
                        </div>
                        <div style={{ float: 'left', width: '70%' }}>
                          <Form.Item className="font-face-gm" name={'newPassword'}   >

                            <Input placeholder={L('Confirm New Password...')} size="large" disabled={this.props.loading} />

                          </Form.Item>
                        </div>

                      </div>  </div>

                    : null}


                  <div style={{ width: '100%', float: 'right', padding: '0', marginBottom: '0px' }}>


                    <Form.Item style={{ margin: '0', float: 'right', marginTop: '8px' }}>
                      <Button disabled={true} onClick={this.handleReset} hidden={this.state.editModeOff} style={{ borderColor: this.props.secondaryColor, }} loading={this.props.loading} size='small' type="dashed" shape='round' className="font-face-gm">
                        {this.state.editModeOff === true ? L('Change Password') : L('Submit')}
                      </Button>
                    </Form.Item>
                  </div>


                </Form>


              </Panel>


              <Panel className="font-face-gm"
                style={{ fontSize: '1.2em' }}
                header={<div style={{ marginLeft: '25px' }}>{L('Languages')}</div>}
                key={'languages'}>



                <LanguageSelect userStore={this.props.userStore} />


              </Panel>


              <Panel className="font-face-gm"
                style={{ fontSize: '1.2em' }}
                header={<div style={{ marginLeft: '25px' }}>{L('Subscription Info')}</div>}
                key={'subscription'}>
                <Card>





                  <div>

                    <div style={{ float: 'left', width: '100%' }}>
                      <Form.Item>
                        <Meta className="font-face-gm" title={<div style={{ fontSize: '1.1em', paddingBottom: '-10px', marginBottom: '5px', }}>{L('Subscription Type')}</div>}
                          description={<div style={{ fontSize: '1.5em', marginTop: '-10px', lineHeight: '15px' }}>{this.props.subscriptionType}</div>}
                        />
                      </Form.Item>
                    </div>
                    <div style={{ float: 'left', width: '100%' }}>
                      <Form.Item>
                        <Meta className="font-face-gm" title={<div style={{ fontSize: '1.1em', paddingBottom: '-10px', marginBottom: '5px', }}>{L('Templates')}</div>}
                          description={<div style={{ fontSize: '1.5em', marginTop: '-10px', lineHeight: '15px' }}>{this.props.availableTemplates}</div>}
                        />
                      </Form.Item>
                    </div>
                    <div style={{ float: 'left', width: '100%' }}>
                      <Form.Item>
                        <Meta className="font-face-gm" title={<div style={{ fontSize: '1.1em', paddingBottom: '-10px', marginBottom: '5px', }}>{L('Subscription Start')}</div>}
                          description={<div style={{ fontSize: '1.5em', marginTop: '-10px', lineHeight: '15px' }}>{this.props.subscriptionStart}</div>}
                        />
                      </Form.Item>
                    </div>
                    <div style={{ float: 'left', width: '100%' }}>
                      <Form.Item>
                        <Meta className="font-face-gm" title={<div style={{ fontSize: '1.1em', paddingBottom: '-10px', marginBottom: '5px', }}>{L('Subscription End')}</div>}
                          description={<div style={{ fontSize: '1.5em', marginTop: '-10px', lineHeight: '15px' }}>{this.props.subscriptionEnd}</div>}
                        />
                      </Form.Item>
                    </div>


                  </div>
                </Card>
              </Panel>

            </Collapse>


          </Drawer>
        </div>

      </div>

    );
  }
}

export default Options;
